/* GENERATED by tools/poppins-metrics from the browser canvas — do not edit by hand. See tools/poppins-metrics/README.md.
 *
 * Poppins advance widths in 1/1000 em, per weight, for the characters content uses. The canvas the content-engine
 * checker measures with applies no pair kerning, so a string is the sum of its characters; the golden test in
 * __tests__/questLines.test.ts holds the sum to the canvas, line for line, over the whole library.
 */
export const POPPINS_UNITS = 1000;
export const POPPINS_KERNED = false;
export const POPPINS_WIDTHS: Readonly<Record<500 | 700 | 800, Readonly<Record<string, number>>>> = {
  500: {
    "0": 641,
    "1": 350,
    "2": 577,
    "3": 594,
    "4": 647,
    "5": 639,
    "6": 642,
    "7": 560,
    "8": 638,
    "9": 635,
    " ": 260,
    "!": 321,
    "\"": 323,
    "#": 872,
    "$": 650,
    "%": 794,
    "&": 761,
    "'": 172,
    "(": 492,
    ")": 492,
    "*": 504,
    "+": 714,
    ",": 225,
    "-": 585,
    ".": 241,
    "/": 514,
    ":": 245,
    ";": 304,
    "<": 612,
    "=": 774,
    ">": 590,
    "?": 538,
    "@": 1025,
    "A": 697,
    "B": 630,
    "C": 773,
    "D": 709,
    "E": 524,
    "F": 515,
    "G": 773,
    "H": 705,
    "I": 264,
    "J": 564,
    "K": 633,
    "L": 444,
    "M": 882,
    "N": 721,
    "O": 784,
    "P": 595,
    "Q": 787,
    "R": 632,
    "S": 604,
    "T": 564,
    "U": 690,
    "V": 694,
    "W": 999,
    "X": 660,
    "Y": 605,
    "Z": 558,
    "[": 485,
    "\\": 717,
    "]": 484,
    "^": 654,
    "_": 798,
    "`": 254,
    "a": 678,
    "b": 678,
    "c": 600,
    "d": 678,
    "e": 617,
    "f": 332,
    "g": 678,
    "h": 649,
    "i": 264,
    "j": 264,
    "k": 554,
    "l": 264,
    "m": 1039,
    "n": 649,
    "o": 638,
    "p": 678,
    "q": 678,
    "r": 384,
    "s": 534,
    "t": 372,
    "u": 649,
    "v": 576,
    "w": 825,
    "x": 499,
    "y": 582,
    "z": 471,
    "{": 516,
    "|": 324,
    "}": 516,
    "~": 553,
    "‘": 242,
    "’": 242,
    "“": 422,
    "”": 422,
    "–": 708,
    "—": 924,
    "…": 638,
    "é": 617,
    "è": 617,
    "á": 678,
    "í": 264,
    "ó": 638,
    "ú": 649,
    "ñ": 649,
    "×": 699,
    "•": 462,
    "·": 244,
  },
  700: {
    "0": 652,
    "1": 376,
    "2": 571,
    "3": 605,
    "4": 677,
    "5": 650,
    "6": 637,
    "7": 535,
    "8": 648,
    "9": 615,
    " ": 212,
    "!": 392,
    "\"": 411,
    "#": 904,
    "$": 658,
    "%": 870,
    "&": 798,
    "'": 221,
    "(": 477,
    ")": 477,
    "*": 534,
    "+": 628,
    ",": 287,
    "-": 580,
    ".": 282,
    "/": 453,
    ":": 284,
    ";": 347,
    "<": 551,
    "=": 696,
    ">": 541,
    "?": 538,
    "@": 1080,
    "A": 737,
    "B": 659,
    "C": 762,
    "D": 727,
    "E": 541,
    "F": 547,
    "G": 762,
    "H": 731,
    "I": 295,
    "J": 578,
    "K": 697,
    "L": 477,
    "M": 918,
    "N": 752,
    "O": 786,
    "P": 624,
    "Q": 788,
    "R": 652,
    "S": 615,
    "T": 591,
    "U": 705,
    "V": 730,
    "W": 1052,
    "X": 715,
    "Y": 671,
    "Z": 596,
    "[": 510,
    "\\": 802,
    "]": 510,
    "^": 709,
    "_": 780,
    "`": 291,
    "a": 679,
    "b": 679,
    "c": 605,
    "d": 679,
    "e": 616,
    "f": 360,
    "g": 679,
    "h": 674,
    "i": 295,
    "j": 294,
    "k": 618,
    "l": 295,
    "m": 1059,
    "n": 674,
    "o": 637,
    "p": 679,
    "q": 679,
    "r": 428,
    "s": 558,
    "t": 406,
    "u": 674,
    "v": 626,
    "w": 866,
    "x": 588,
    "y": 632,
    "z": 496,
    "{": 499,
    "|": 291,
    "}": 499,
    "~": 636,
    "‘": 314,
    "’": 314,
    "“": 541,
    "”": 541,
    "–": 695,
    "—": 930,
    "…": 760,
    "é": 616,
    "è": 616,
    "á": 679,
    "í": 321,
    "ó": 637,
    "ú": 674,
    "ñ": 674,
    "×": 637,
    "•": 501,
    "·": 299,
  },
  800: {
    "0": 657,
    "1": 387,
    "2": 569,
    "3": 610,
    "4": 691,
    "5": 655,
    "6": 635,
    "7": 523,
    "8": 653,
    "9": 606,
    " ": 191,
    "!": 423,
    "\"": 451,
    "#": 919,
    "$": 661,
    "%": 904,
    "&": 814,
    "'": 243,
    "(": 470,
    ")": 470,
    "*": 548,
    "+": 589,
    ",": 314,
    "-": 578,
    ".": 301,
    "/": 426,
    ":": 302,
    ";": 366,
    "<": 524,
    "=": 661,
    ">": 519,
    "?": 538,
    "@": 1104,
    "A": 755,
    "B": 671,
    "C": 758,
    "D": 735,
    "E": 548,
    "F": 561,
    "G": 757,
    "H": 743,
    "I": 308,
    "J": 584,
    "K": 726,
    "L": 491,
    "M": 935,
    "N": 765,
    "O": 787,
    "P": 636,
    "Q": 788,
    "R": 661,
    "S": 620,
    "T": 604,
    "U": 712,
    "V": 747,
    "W": 1076,
    "X": 739,
    "Y": 701,
    "Z": 613,
    "[": 522,
    "\\": 840,
    "]": 521,
    "^": 733,
    "_": 772,
    "`": 307,
    "a": 680,
    "b": 680,
    "c": 607,
    "d": 680,
    "e": 616,
    "f": 373,
    "g": 680,
    "h": 686,
    "i": 308,
    "j": 307,
    "k": 647,
    "l": 308,
    "m": 1067,
    "n": 686,
    "o": 636,
    "p": 680,
    "q": 680,
    "r": 447,
    "s": 568,
    "t": 421,
    "u": 686,
    "v": 649,
    "w": 885,
    "x": 628,
    "y": 655,
    "z": 507,
    "{": 492,
    "|": 277,
    "}": 492,
    "~": 674,
    "‘": 346,
    "’": 346,
    "“": 595,
    "”": 595,
    "–": 689,
    "—": 933,
    "…": 815,
    "é": 616,
    "è": 616,
    "á": 680,
    "í": 347,
    "ó": 636,
    "ú": 686,
    "ñ": 686,
    "×": 609,
    "•": 519,
    "·": 324,
  },
};
